var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"zzshr","width":_vm.contentWidth,"height":_vm.contentHeight},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }